(function() {
  'use strict';

  var PRODUCT_ASSETS = {
    CM02: 'petomg-cat-wall-guide-CM02.jpg',
    CM03: 'petomg-cat-wall-guide-CM03.jpg',
    CM04: 'petomg-cat-wall-guide-CM04.jpg',
    CM05: 'petomg-cat-wall-guide-CM05.jpg',
    CM06: 'petomg-cat-wall-guide-CM06.jpg',
    CM07: 'petomg-cat-wall-guide-CM07.jpg',
    CM09: 'petomg-cat-wall-guide-CM09.jpg',
    CM12: 'petomg-cat-wall-guide-CM12.png',
    CM15: 'petomg-cat-wall-guide-CM15.jpg',
    CM18: 'petomg-cat-wall-guide-CM18.jpg',
    CM23: 'petomg-cat-wall-guide-CM23.jpg',
    CM24: 'petomg-cat-wall-guide-CM24.jpg',
    CM26: 'petomg-cat-wall-guide-CM26.png',
    CM27: 'petomg-cat-wall-guide-CM27.jpg',
    CM28: 'petomg-cat-wall-guide-CM28.jpg',
    CM29: 'petomg-cat-wall-guide-CM29.jpg'
  };

  var GUIDE_02_ROLES = {
    connector: {
      kicker: 'CONNECTION UNITS',
      title: 'Move between levels and route sections.',
      copy: 'CM04, CM05, CM07 and CM18 are primarily small route connectors. They support grip, climbing, stepping or traversal, but should not automatically be treated as full turnaround or long-rest platforms.',
      items: [
        { sku: 'CM05', name: 'Ladder-style connector' },
        { sku: 'CM07', name: 'Small transition steps' }
      ]
    },
    platform: {
      kicker: 'PAUSE / TURN / BUFFER UNITS',
      title: 'Create more meaningful repositioning space.',
      copy: 'CM06, CM12, CM26 and CM27 provide comparatively more space for pausing, observing or changing direction. Actual suitability still depends on the cat, approach direction and final installation conditions.',
      items: [
        { sku: 'CM12', name: 'Double-level route hub' },
        { sku: 'CM26', name: 'Lookout and pause platform' }
      ]
    },
    destination: {
      kicker: 'DESTINATION UNITS',
      title: 'Give the route a reason to exist.',
      copy: 'CM03, CM09, CM15, CM23, CM24 and other destination units support resting, observing, hiding or exploration. CM28 and CM29 are corner-only products and must be planned for a corner.',
      items: [
        { sku: 'CM09', name: 'Bubble lookout destination' },
        { sku: 'CM24', name: 'Hexagon bubble house' }
      ]
    }
  };

  var GUIDE_05_UNITS = {
    connect: [
      { sku: 'CM04', name: 'Compact scratch & grip point', summary: 'A compact scratch, grip and climbing connection point.', boundary: 'Not automatically a full turnaround or long-rest platform.' },
      { sku: 'CM05', name: 'Ladder-style connector', summary: 'Supports transitions between different heights with a clear ladder form.', boundary: 'Judge the approach from both ends of the ladder.' },
      { sku: 'CM07', name: 'Small transition steps', summary: 'Small stepping platforms used to fill movement gaps between larger units.', boundary: 'Standalone product title identifies a set of two.' },
      { sku: 'CM18', name: 'Traverse & scratch bar', summary: 'A horizontal grip, scratch and route connector that can support traversal.', boundary: 'Any alternative orientation remains installation-dependent.' }
    ],
    pause: [
      { sku: 'CM06', name: 'Compact platform', summary: 'The smallest platform-type unit; useful as a route step with some pause value.', boundary: 'Repositioning suitability depends on the actual cat.' },
      { sku: 'CM12', name: 'Double-level route hub', summary: 'Supports ascending, descending, pausing, scratching and body repositioning.', boundary: 'Use it as part of a route, not as proof that every cat can turn there.' },
      { sku: 'CM26', name: 'Guard-rail lookout platform', summary: 'A larger lookout for mid-route pause, observation, rest and repositioning.', boundary: 'Approach direction still affects how the platform works.' },
      { sku: 'CM27', name: 'Long platform', summary: 'The most generous conventional platform in the current CM family.', boundary: 'More space does not replace the need for a clear next move.' }
    ],
    destination: [
      { sku: 'CM02', name: 'Tunnel-style cat cave', summary: 'A large covered tunnel for hiding, passing through, exploring and resting.', boundary: 'Not referenced by the current confirmed NC set descriptions.' },
      { sku: 'CM03', name: 'Open hammock rest', summary: 'A soft elevated rest destination with an open linen sling.', boundary: 'An open rest experience - not an enclosed hideaway.' },
      { sku: 'CM09', name: 'Bubble lookout', summary: 'A clear-bowl lookout and lounging destination with strong visibility.', boundary: 'Plan a readable approach into and away from the bowl.' },
      { sku: 'CM15', name: 'Medium hideaway house', summary: 'A sheltered elevated house for resting and hiding.', boundary: 'Pair the entrance with an adequate approach or buffer.' },
      { sku: 'CM23', name: 'Open hexagon house', summary: 'A large open house with side-entry, resting and pass-through value.', boundary: 'Its larger form still needs a planned connection and return.' },
      { sku: 'CM24', name: 'Hexagon bubble house', summary: 'Combines hiding, resting and observing in a large bubble house.', boundary: 'Treat it as a destination, not as the whole route.' },
      { sku: 'CM28', name: 'Corner hideaway', summary: 'A large sheltered destination designed to use room-corner geometry.', boundary: 'Corner placement only.' },
      { sku: 'CM29', name: 'Corner bubble lookout', summary: 'A corner-only bubble lookout and resting destination.', boundary: 'Corner placement only.' }
    ]
  };

  var GUIDE_05_COMMERCE = {
    CM02: { variantId: 44481718354092, price: '$119.00', handle: 'large-cat-wall-tunnel-cm02', available: true },
    CM03: { variantId: 44345117474988, price: '$59.00', handle: 'petomg-cat-hammock-cat-wall-furniture-cat-wall-bed-rubberwood', available: true },
    CM04: { variantId: 42265279824044, price: '$49.00', handle: 'petomg-cat-scratching-post-cat-wall-steps-cat-walks2pcs-rubberwood', available: true },
    CM05: { variantId: 42265285296300, price: '$49.00', handle: 'petomg-cat-wall-steps-cat-ladder-cat-climbers-for-walls-rubberwood', available: true },
    CM06: { variantId: 42265307447468, price: '$46.00', handle: 'petomg-cat-wall-steps-cat-shelf-cat-ladder-cat-walks-rubberwood', available: true },
    CM07: { variantId: 42265317048492, price: '$46.00', handle: 'petomg-cat-wall-steps-cat-shelf-cat-ladder-cat-walks2pcs-rubberwood', available: true },
    CM09: { variantId: 42265333137580, price: '$69.00', handle: 'petomg-cat-perch-cat-space-capsule-cat-bed-furniture-cat-wall-mounted-rubber-wood', available: true },
    CM12: { variantId: 42265331663020, price: '$69.00', handle: 'petomg-cat-wall-steps-cat-ladder-cat-walks-cat-climbers-for-walls-rubberwood', available: true },
    CM15: { variantId: 42265334251692, price: '$69.00', handle: 'petomg-wall-mounted-cat-house-cat-wall-furniture-cat-wall-bed-rubberwood', available: true },
    CM18: { variantId: 42265339330732, price: '$49.00', handle: 'petomg-cat-scratching-post-cat-wall-furniture-cat-shelf-rubberwood', available: true },
    CM23: { variantId: 42265354010796, price: '$109.00', handle: 'petomg-wall-mounted-cat-house-cat-wall-shelf-large-cat-wall-bed-rubberwood', available: true },
    CM24: { variantId: 42265357877420, price: '$119.00', handle: 'petomg-cat-wall-house-cat-perch-large-cat-shelf-with-spaceship-rubberwood', available: true },
    CM26: { variantId: 42265358532780, price: '$54.00', handle: 'petomg-cat-perch-cat-wall-bed-cat-shelf-wall-rubberwood', available: true },
    CM27: { variantId: 42337207124140, price: '$59.00', handle: 'petomg-cat-wall-steps-cat-walks-cat-ladder-cat-wall-shelf-rubberwood', available: true },
    CM28: { variantId: 42337210630316, price: '$89.00', handle: 'petomg-wall-mounted-cat-house-cat-shelf-cat-perch-rubberwood', available: true },
    CM29: { variantId: 42502261768364, price: '$89.00', handle: 'petomg-cat-perch-cat-shelf-wall-mounted-cat-furniture-cat-spaceship-rubberwood', available: true }
  };

  var GUIDE_05_COPY = {
    connect: {
      kicker: 'CONNECTION SHORTLIST',
      title: 'Compare how the cat moves from one point to the next.',
      copy: 'Use these when the missing job is traversal or a height transition. Then check whether the route also needs a separate place to pause or turn.'
    },
    pause: {
      kicker: 'PAUSE / TURN SHORTLIST',
      title: 'Compare how much meaningful repositioning space is needed.',
      copy: 'Use these when a compact connector is being asked to do too much, especially before a direction change, destination entrance or shared route.'
    },
    destination: {
      kicker: 'DESTINATION SHORTLIST',
      title: 'Choose the experience the cat should reach.',
      copy: 'Compare open rest, lookout, sheltered hideaway, tunnel and corner experiences. A destination still needs a readable approach and return.'
    }
  };

  function initAll(context) {
    var scope = context || document;
    scope.querySelectorAll('.petomg-cat-wall-guide[data-guide]').forEach(initGuide);
  }

  function initGuide(root) {
    if (!root || root.dataset.petomgGuideInitialized === 'true') return;
    root.dataset.petomgGuideInitialized = 'true';

    var guide = root.dataset.guide;
    if (guide === '01') initGuide01(root);
    if (guide === '02') initGuide02(root);
    if (guide === '03') initGuide03(root);
    if (guide === '04') initGuide04(root);
    if (guide === '05') initGuide05(root);
    if (guide === '07') initGuide07(root);
    if (guide === '08') initGuide08(root);
  }

  function sectionFor(root) {
    return root.closest('[data-petomg-cat-wall-guide-section]');
  }

  function assetUrl(root, fileName) {
    var section = sectionFor(root);
    var explicitBase = section && section.dataset.assetBase ? section.dataset.assetBase.trim() : '';
    if (explicitBase) return explicitBase.replace(/\/$/, '') + '/' + fileName;

    var image = root.querySelector('img[src]');
    if (image) {
      var src = image.getAttribute('src');
      if (src && src.indexOf('__PETOMG_FILE_CDN__') === -1) {
        return src.replace(/\/[^/?#]+([?#].*)?$/, '/' + fileName);
      }
    }

    return fileName;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function setHtml(node, html) {
    if (node) node.innerHTML = html;
  }

  function initGuide01(root) {
    var checks = Array.prototype.slice.call(root.querySelectorAll('[data-check]'));
    var risk = root.querySelector('[data-risk]');
    var result = root.querySelector('#check-result');
    if (!checks.length || !risk || !result) return;

    function updateResult() {
      var complete = checks.every(function(item) { return item.checked; });
      result.classList.remove('ready', 'caution');

      if (risk.checked) {
        result.classList.add('caution');
        setHtml(result, '<span>YOUR NEXT STEP</span><h3>Pause before choosing a layout.</h3><p>Your remaining uncertainty needs technical or qualified local confirmation. Measurements and photographs cannot resolve wall construction, damage, hidden utilities or fastening decisions.</p>');
        return;
      }

      if (complete) {
        result.classList.add('ready');
        setHtml(result, '<span>YOUR NEXT STEP</span><h3>Your wall record is ready for route planning.</h3><p>You can now compare how a cat would enter, move, pause, reach a destination and return without guessing about the visible room boundary.</p>');
        return;
      }

      var missing = checks.filter(function(item) { return !item.checked; }).length;
      setHtml(result, '<span>YOUR NEXT STEP</span><h3>Finish ' + missing + ' planning record' + (missing === 1 ? '' : 's') + ' first.</h3><p>Complete the unchecked items before comparing product layouts. This prevents a missing room detail from becoming a route problem later.</p>');
    }

    checks.concat(risk).forEach(function(item) {
      item.addEventListener('change', updateResult);
    });
    updateResult();
  }

  function initGuide02(root) {
    var panel = root.querySelector('#role-panel');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    var routeChecks = Array.prototype.slice.call(root.querySelectorAll('[data-route]'));
    var bottleneck = root.querySelector('[data-bottleneck]');
    var routeResult = root.querySelector('#route-result');

    function productCard(item) {
      var image = assetUrl(root, PRODUCT_ASSETS[item.sku]);
      return '<article class="product"><img src="' + escapeHtml(image) + '" alt="' + escapeHtml(item.sku + ' ' + item.name) + '"><div><p class="sku">' + escapeHtml(item.sku) + '</p><h4>' + escapeHtml(item.name) + '</h4><p>Use this unit only after its role in the full route is clear.</p></div></article>';
    }

    function renderRole(key) {
      var role = GUIDE_02_ROLES[key];
      if (!panel || !role) return;
      setHtml(panel, '<div class="panel-grid"><div class="panel-copy"><p class="eyebrow light">' + escapeHtml(role.kicker) + '</p><h3>' + escapeHtml(role.title) + '</h3><p>' + escapeHtml(role.copy) + '</p><small>Role labels help compare functions; they do not establish universal spacing, load or wall compatibility.</small></div><div class="product-grid">' + role.items.map(productCard).join('') + '</div></div>');

      tabs.forEach(function(tab) {
        var active = tab.dataset.tab === key;
        tab.classList.toggle('active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        renderRole(tab.dataset.tab);
      });
    });
    renderRole('connector');

    function updateRouteResult() {
      if (!routeResult || !bottleneck) return;
      var missing = routeChecks.filter(function(item) { return !item.checked; }).map(function(item) { return item.dataset.route; });
      routeResult.classList.remove('ready', 'caution');

      if (bottleneck.checked) {
        routeResult.classList.add('caution');
        setHtml(routeResult, '<span>YOUR NEXT DECISION</span><h3>The route still depends on a bottleneck.</h3><p>Add choice, a more meaningful pause point, or another way to leave before treating the route as complete, especially in a multi-cat home.</p>');
        return;
      }

      if (!missing.length) {
        routeResult.classList.add('ready');
        setHtml(routeResult, '<span>YOUR NEXT DECISION</span><h3>Your route logic is complete.</h3><p>You can now compare which CM modules or NC set provide these jobs on your measured wall. Exact spacing and installation still require separate confirmation.</p>');
        return;
      }

      setHtml(routeResult, '<span>YOUR NEXT DECISION</span><h3>Resolve ' + escapeHtml(missing.join(', ')) + '.</h3><p>Do not add products at random. Decide how the missing ' + (missing.length === 1 ? 'job works' : 'jobs work') + ' within the whole journey first.</p>');
    }

    routeChecks.concat(bottleneck || []).forEach(function(item) {
      if (item) item.addEventListener('change', updateRouteResult);
    });
    updateRouteResult();
  }

  function initGuide03(root) {
    var form = root.querySelector('#profile-form');
    var result = root.querySelector('#profile-result');
    if (!form || !result) return;

    var priorities = {
      lowEntry: '<b>Entry & return:</b> connect the wall to a familiar lower or intermediate surface and review descent as a separate route.',
      turn: '<b>Landing & turning:</b> compare platform or buffer roles where the cat must stop, reposition or reverse.',
      choice: '<b>Visibility & retreat:</b> keep the next landing visible and provide a pause or exit near uncertain transitions.',
      rest: '<b>Intermediate recovery:</b> avoid a route made only of small connectors; add meaningful pause points before the destination.'
    };

    form.addEventListener('submit', function(event) {
      event.preventDefault();
      var data = new FormData(form);
      result.classList.remove('active', 'warning');

      if (data.has('sudden')) {
        result.classList.add('warning');
        setHtml(result, '<span>PAUSE ROUTE PLANNING</span><h3>Start with veterinary assessment.</h3><p>A sudden change in jumping, movement or willingness can indicate pain or another medical issue. Resume route planning after the cat\'s current capability is understood.</p>');
        return;
      }

      var selected = Object.keys(priorities).filter(function(key) { return data.has(key); });
      if (!selected.length) {
        result.classList.add('warning');
        setHtml(result, '<span>MORE OBSERVATION NEEDED</span><h3>Select at least one repeatable movement pattern.</h3><p>Record normal entry, landing, turning and descent before choosing modules.</p>');
        return;
      }

      result.classList.add('active');
      setHtml(result, '<span>FIRST ROUTE PRIORITIES</span><h3>Review ' + selected.length + ' linked decision' + (selected.length > 1 ? 's' : '') + '.</h3><div class="priority-list">' + selected.map(function(key) { return '<p>' + priorities[key] + '</p>'; }).join('') + '</div>');
    });
  }

  function initGuide04(root) {
    var form = root.querySelector('#route-audit');
    var result = root.querySelector('#audit-result');
    if (!form || !result) return;

    var priorities = {
      singleEntry: '<b>Add another practical access:</b> connect a second familiar furniture or floor approach where the real wall and installation conditions allow it.',
      singleSpine: '<b>Create a bypass:</b> branch before the controlled connector so all destinations do not depend on the same narrow passage.',
      sharedPrize: '<b>Distribute destination value:</b> separate comparable rest, lookout or hiding experiences rather than concentrating preference in one place.',
      deadEnd: '<b>Protect the return:</b> add a reversal buffer, alternative descent or exit choice before the destination becomes occupied.',
      differentNeeds: '<b>Plan two movement experiences:</b> preserve intermediate pauses for the slower or cautious cat without turning them into obstacles for the faster cat.'
    };

    form.addEventListener('submit', function(event) {
      event.preventDefault();
      var data = new FormData(form);
      result.classList.remove('active', 'warning');

      if (data.has('tension')) {
        result.classList.add('warning');
        setHtml(result, '<span>WIDEN THE RESPONSE</span><h3>Do not rely on the cat wall alone.</h3><p>Persistent chasing, fear, injury or resource avoidance calls for veterinary or qualified feline-behavior guidance and a review of separated resources throughout the home. Route changes can support that plan, but they are not a diagnosis or complete treatment.</p>');
        return;
      }

      var selected = Object.keys(priorities).filter(function(key) { return data.has(key); });
      if (!selected.length) {
        result.classList.add('warning');
        setHtml(result, '<span>OBSERVE BEFORE REVISING</span><h3>Select at least one repeated access pattern.</h3><p>Watch normal use at different times and mark where a cat waits, turns away or loses access.</p>');
        return;
      }

      result.classList.add('active');
      setHtml(result, '<span>FIRST REVISION PRIORITIES</span><h3>Resolve ' + selected.length + ' structural decision' + (selected.length > 1 ? 's' : '') + '.</h3><div class="priority-list">' + selected.map(function(key) { return '<p>' + priorities[key] + '</p>'; }).join('') + '</div>');
    });
  }

  function initGuide05(root) {
    var commerceEnabled = sectionFor(root) && sectionFor(root).dataset.enableGuide05Commerce === 'true';

    root.querySelectorAll('[data-role]').forEach(function(button) {
      button.addEventListener('click', function() {
        renderGuide05Role(root, button.dataset.role, commerceEnabled);
      });
    });

    Object.keys(GUIDE_05_UNITS).forEach(function(role) {
      var grid = root.querySelector('#' + role + '-grid');
      if (grid) setHtml(grid, GUIDE_05_UNITS[role].map(function(unit) {
        return guide05UnitCard(root, unit, true, commerceEnabled);
      }).join(''));
    });

    root.querySelectorAll('input[name="need"]').forEach(function(input) {
      input.addEventListener('change', function() {
        renderGuide05Shortlist(root, input.value);
      });
    });

    if (commerceEnabled) {
      root.addEventListener('click', function(event) {
        var button = event.target.closest('[data-petomg-guide-add-to-cart]');
        if (!button || !root.contains(button)) return;
        addGuide05Unit(root, button);
      });
    }

    renderGuide05Role(root, 'connect', commerceEnabled);
    renderGuide05Shortlist(root, 'connect');
  }

  function guide05ProductUrl(unit) {
    var item = GUIDE_05_COMMERCE[unit.sku];
    return item ? '/products/' + item.handle : '#';
  }

  function guide05UnitCard(root, unit, compact, commerceEnabled) {
    var item = GUIDE_05_COMMERCE[unit.sku] || {};
    var productUrl = guide05ProductUrl(unit);
    var image = assetUrl(root, PRODUCT_ASSETS[unit.sku]);
    var action = '<a class="quick-add" href="' + escapeHtml(productUrl) + '">View product</a>';

    if (commerceEnabled) {
      action = '<button class="quick-add" type="button" data-petomg-guide-add-to-cart data-variant-id="' + escapeHtml(item.variantId) + '" data-sku="' + escapeHtml(unit.sku) + '"' + (item.available ? '' : ' disabled') + '>' + (item.available ? 'Add to cart' : 'Unavailable') + '</button>';
    }

    return '<article class="' + (compact ? 'mini-card' : 'unit-card') + '"><a class="product-image-link" href="' + escapeHtml(productUrl) + '" aria-label="View ' + escapeHtml(unit.sku + ' ' + unit.name) + '"><img src="' + escapeHtml(image) + '" alt="PETOMG ' + escapeHtml(unit.sku + ' ' + unit.name) + '"></a><div><div class="product-meta"><p class="sku">' + escapeHtml(unit.sku) + '</p><strong class="product-price">' + escapeHtml(item.price || '') + '</strong></div><h3><a href="' + escapeHtml(productUrl) + '">' + escapeHtml(unit.name) + '</a></h3><p>' + escapeHtml(unit.summary) + '</p><small>' + escapeHtml(unit.boundary) + '</small>' + action + '</div></article>';
  }

  function renderGuide05Role(root, role, commerceEnabled) {
    var copy = GUIDE_05_COPY[role];
    var panel = root.querySelector('#unit-results');
    if (!copy || !panel) return;

    setHtml(panel, '<div class="result-intro"><p class="eyebrow light">' + escapeHtml(copy.kicker) + '</p><h3>' + escapeHtml(copy.title) + '</h3><p>' + escapeHtml(copy.copy) + '</p></div><div class="result-cards">' + GUIDE_05_UNITS[role].map(function(unit) {
      return guide05UnitCard(root, unit, false, commerceEnabled);
    }).join('') + '</div>');

    root.querySelectorAll('[data-role]').forEach(function(button) {
      var active = button.dataset.role === role;
      button.classList.toggle('active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function renderGuide05Shortlist(root, role) {
    var copy = GUIDE_05_COPY[role];
    var result = root.querySelector('#shortlist-result');
    if (!copy || !result) return;

    var names = GUIDE_05_UNITS[role].map(function(unit) { return unit.sku; }).join(' / ');
    setHtml(result, '<span>COMPARE THESE FIRST</span><h3>' + escapeHtml(names) + '</h3><p>' + escapeHtml(copy.copy) + '</p><a href="#choose-role">See the functional comparison</a>');
  }

  async function addGuide05Unit(root, button) {
    if (button.disabled) return;

    var originalLabel = button.textContent;
    var variantId = Number(button.dataset.variantId);
    var sku = button.dataset.sku;
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      var isLocalPreview = ['127.0.0.1', 'localhost', ''].indexOf(window.location.hostname) !== -1 || window.location.protocol === 'file:';
      var responseData = { variant_id: variantId };

      if (!isLocalPreview) {
        responseData = await postCartAdd(variantId);
      } else {
        await new Promise(function(resolve) { window.setTimeout(resolve, 300); });
      }

      root.querySelectorAll('[data-variant-id="' + variantId + '"]').forEach(function(match) {
        match.textContent = 'Added';
        match.classList.add('added');
      });
      updateCartSurfaces(responseData);
      showGuide05Feedback(root, sku + ' has been added to your cart.', 'success');

      window.setTimeout(function() {
        root.querySelectorAll('[data-variant-id="' + variantId + '"]').forEach(function(match) {
          match.textContent = originalLabel;
          match.classList.remove('added');
          match.disabled = false;
        });
      }, 2200);
    } catch (error) {
      button.textContent = 'Try again';
      button.disabled = false;
      showGuide05Feedback(root, error.message || 'Unable to add this item. Please try again.', 'error');
    }
  }

  async function postCartAdd(variantId) {
    var cartDrawer = document.querySelector('cart-drawer');
    var sections = 'cart-icon-bubble';
    if (cartDrawer && cartDrawer.closest('.shopify-section')) {
      sections += ',' + cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');
    }

    var response = await fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      })
    });
    var data = await response.json().catch(function() { return {}; });

    if (!response.ok) {
      throw new Error(data.description || data.message || 'Shopify returned ' + response.status);
    }

    return data;
  }

  function updateCartSurfaces(responseData) {
    var cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && responseData.sections && responseData.sections['cart-icon-bubble']) {
      cartIconBubble.innerHTML = responseData.sections['cart-icon-bubble'];
    }

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function' && responseData.sections) {
      cartDrawer.renderContents(responseData, window.theme && theme.settings && theme.settings.afterAtc === 'drawer');
    }

    document.dispatchEvent(new CustomEvent('on:cart:add', {
      bubbles: true,
      detail: {
        variantId: responseData.variant_id
      }
    }));
  }

  function showGuide05Feedback(root, message, state) {
    var feedback = root.querySelector('.cart-feedback');
    if (!feedback) {
      feedback = document.createElement('div');
      feedback.className = 'cart-feedback';
      feedback.hidden = true;
      feedback.innerHTML = '<span></span><a href="/cart">View cart</a>';
      root.appendChild(feedback);
    }

    feedback.dataset.state = state || 'success';
    feedback.querySelector('span').textContent = message;
    feedback.hidden = false;
    window.clearTimeout(feedback._petomgTimer);
    feedback._petomgTimer = window.setTimeout(function() {
      feedback.hidden = true;
    }, 5000);
  }

  function initGuide07(root) {
    var form = root.querySelector('#readiness-form');
    var result = root.querySelector('#readiness-result');
    if (!form || !result) return;

    var labels = {
      wall: 'Identify the wall structure',
      guide: 'Find the exact product instructions',
      route: 'Position the complete route together',
      services: 'Resolve obstacles and hidden-service risk',
      capacity: 'Confirm the work is within your capability'
    };

    form.addEventListener('submit', function(event) {
      event.preventDefault();
      var missing = Array.prototype.slice.call(form.elements)
        .filter(function(control) { return control.type === 'checkbox' && !control.checked; })
        .map(function(control) { return labels[control.name]; })
        .filter(Boolean);

      result.classList.remove('ready', 'stop');
      if (!missing.length) {
        result.classList.add('ready');
        setHtml(result, '<span>RESULT - POSITIONING GATE COMPLETE</span><h3>You have resolved the planning inputs.</h3><p>Proceed to the product-specific instructions and positioning stage. This result is not structural or installation approval.</p>');
        return;
      }

      result.classList.add('stop');
      setHtml(result, '<span>RESULT - DO NOT DRILL YET</span><h3>' + missing.length + ' item' + (missing.length > 1 ? 's' : '') + ' still need an answer.</h3><p>' + escapeHtml(missing.join(' / ')) + '.</p>');
    });
  }

  function initGuide08(root) {
    var form = root.querySelector('#barrier-form');
    var result = root.querySelector('#barrier-result');
    if (!form || !result) return;

    var guidance = {
      entry: {
        label: 'FIRST ACTION - REBUILD THE ENTRY',
        title: 'Start from the cat\'s familiar surface.',
        text: 'Identify where the cat already walks, rests or watches. Check whether the first module is visible and voluntarily reachable from that point before working on the upper route.'
      },
      confidence: {
        label: 'FIRST ACTION - INSPECT THE STOP POINT',
        title: 'Check the repeated transition before adding motivation.',
        text: 'Block access if anything moves or is damaged. Otherwise inspect direction, landing, turning room, surface experience and any sound at the exact place the cat retreats.'
      },
      destination: {
        label: 'FIRST ACTION - GIVE THE ROUTE A REASON',
        title: 'Keep the successful lower route and examine the destination.',
        text: 'Ask whether the unused section offers rest, observation, hiding, scratching or interaction value in a location the cat already cares about. Change one destination cue at a time.'
      },
      multicat: {
        label: 'FIRST ACTION - TEST ACCESS WITHOUT COMPETITION',
        title: 'Observe each cat\'s route separately.',
        text: 'Check whether the waiting cat enters when the other cat is elsewhere. If so, review the entry, high-value destination and return route for a bottleneck or blocked escape choice.'
      },
      sudden: {
        label: 'FIRST ACTION - STOP AND FIND WHAT CHANGED',
        title: 'Treat sudden avoidance differently from first-time hesitation.',
        text: 'Inspect the installation and route for movement, damage or a frightening event. If jumping, movement or behavior changed suddenly, contact a veterinarian before restarting the introduction.'
      }
    };

    form.addEventListener('submit', function(event) {
      event.preventDefault();
      var selected = new FormData(form).get('barrier');
      result.classList.remove('active', 'warning');

      if (!selected) {
        result.classList.add('warning');
        setHtml(result, '<span>ONE OBSERVATION IS NEEDED</span><h3>Select the first observable pattern.</h3><p>Choose what happens before interpreting why it happens.</p>');
        return;
      }

      var item = guidance[selected];
      result.classList.add('active');
      setHtml(result, '<span>' + escapeHtml(item.label) + '</span><h3>' + escapeHtml(item.title) + '</h3><p>' + escapeHtml(item.text) + '</p>');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
}());
